import { ReactNode } from 'react';
import { ChangePopoverContent } from './ChangePopoverContent';
import { MODEL_ID_ATTRIBUTE, MODEL_ID_SELECTOR } from 'consts';

export const resolveChangedPopover = (
  trigger: HTMLElement | SVGElement
): ReactNode | null => {
  const element = trigger.closest(
    `.component-item[data-id], ${MODEL_ID_SELECTOR}`
  );

  if (!(element instanceof HTMLElement || element instanceof SVGElement)) {
    return null;
  }
  const id = element.dataset.id || element.getAttribute(MODEL_ID_ATTRIBUTE);
  if (!id) {
    return null;
  }

  return <ChangePopoverContent entityId={id} />;
};
